var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth",class:_vm.$mq},[_c('section',[_c('Logo'),_vm._t("default")],2),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }